import React from "react";
import { Navigate } from "react-router-dom";
import { getUserId } from "utils/auth";

export default function ProtectedRoute({ children }) {
  const uid = getUserId();
  if (!uid) {
    return <Navigate to="/login" replace />;
  }
  return children;
}